import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT } from '@iot-platform/core';
import { DeviceConnectivityModule, Environment } from '@iot-platform/models/common';
import { Observable } from 'rxjs';

export abstract class AbstractDeviceConnectivityModuleService<T> {
  protected readonly environment: Environment = inject(ENVIRONMENT);
  protected readonly httpClient: HttpClient = inject(HttpClient);

  abstract getConnectivityDetails(device: T): Observable<DeviceConnectivityModule>;

  resetConnectivityModule(identifier: string): Observable<DeviceConnectivityModule> {
    return this.httpClient.post<DeviceConnectivityModule>(
      `${this.environment.api.url}${this.environment.api.endpoints.deviceDetails}/${identifier}/connectivity-module/reset`,
      {}
    );
  }
}
